export default "assets/images/testimonials-bg-41f60508.jpg";